class SessionTimeoutService {
    private timeoutId: number | null = null;
    private timeoutDuration: number;

    constructor(timeoutDuration: number) {
        this.timeoutDuration = timeoutDuration;
    }

    setTimeoutDuration(timeoutDuration: number) {
        this.timeoutDuration = timeoutDuration;
    }

    start(onTimeout: () => void) {
        this.clear();
        this.timeoutId = window.setTimeout(onTimeout, this.timeoutDuration);
    }

    reset(onTimeout: () => void) {
        this.start(onTimeout);
    }

    clear() {
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
}

export default SessionTimeoutService;
